import React from "react";
import { Modal, paddingModalStyles } from '@futures-platform/ui'
import { requestTranslation } from '@futures-platform/i18n'

const DeleteConfirmationModalForSector = ({
  deleteSectorHandler,
  deleteConfirmationModal,
  deleteConfirmationModalClose,
  sector,
  fetchRadar
}) => {
    const deleteSectorFunc = (chosenSector) => {
        deleteSectorHandler(chosenSector)
        // fetchRadar()
    }
  return (
    <Modal
      isOpen={deleteConfirmationModal}
      contentLabel="radar-modal"
      ariaHideApp={false}
      style={paddingModalStyles}
    >
      <div className="confirmation-modal-content pt-4 pb-4">
        <h3 className="confirmation-modal-title">
          {requestTranslation('deleteSectorConfirmationMainText')}
        </h3>
        <p className="confirmation-modal-title">{requestTranslation('deleteSectorConfirmationSubText')}</p>
        {/* <p style={{textAlign: 'center', marginLeft: '110px', marginRight: '117px'}}>{requestTranslation("deletePublicLinkConfirmationNote")}</p> */}
        <div className="confirmation-modal-actions">
          <button
            onClick={deleteConfirmationModalClose}
            className="btn btn-lg btn-plain-gray"
          >
            {requestTranslation("cancel").toUpperCase()}
          </button>
          <button
            className="btn btn-lg btn-primary"
            onClick={() => deleteSectorFunc(sector)}
          >
            {requestTranslation("deleteBtn").toUpperCase()}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModalForSector;
